import React from 'react';

type MeasurementSvgIconProps = {
    stroke?: string;
    distance?: number;
};

const MeasurementSvgIcon: React.FC<MeasurementSvgIconProps> = ({stroke, distance = 100}) => (
    <svg width={distance} height={10} xmlns="http://www.w3.org/2000/svg">
        <g>
            <title>Layer 1</title>
            <line id="svg_4" stroke={`${stroke}`} y2={10} x2={distance} y1={10} x1={0} fill="none" />
            <line strokeWidth={6} id="svg_9" stroke={`${stroke}`} y2={10} x2={0} y1={0} x1={0} fill="none" />
            <line strokeWidth={6} id="svg_10" stroke={`${stroke}`} y2={10} x2={distance} y1={0} x1={distance} fill="none" />
        </g>
    </svg>
);

export default MeasurementSvgIcon;
